export default {
  home: "Home",
  user: "User",
  users: "Users",
  role: "Role",
  roles: "Roles",
  permission: "Permission",
  permissions: "Permissions",
  workplace: "Workplace",
  workplaces: "Workplaces",
  office: "Company",
  offices: "Companies",
  profile: "Profile",
  exit: "Exit",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Info",
  basicInfo: "Basic information",
  inn: "TIC", //taxpayer identification code
  kpp: "TRRC", //tax registration reason code
  okpo: "OKPO",
  details: "Details",
  Bank: "Bank",
  corrAccount: "Correspondent account",
  currentAccount: "Current account",
  bik: "Bank Identification Code",
  token: "Digital signature token",
  foreignBankAccounts: "Foreign bank accounts",
  search: "Search",
  ceo: "CEO",
  basedOn: "Based on",
  proxy: "Proxy",
  name: "Name",
  description: "Description",
  action: "Action",
  numberOfRecords: "Number of records",
  information: "Information",
  key: "Key",
  module: "Module",
  close: "Close",
  rowsPerPage: "Rows per page",
  changePassword: "Change password",
  firstName: "First name",
  lastName: "Last name",
  email: "Email",
  password: "Password",
  login: "Login",
  authorization: "Authorization",
  signIn: "Sign in",
  removalDesc: "Are you sure you want to delete this item?",
  removal: "Removal",
  post: "Post",
  userLogin: "User login",
  surname: "Surname",
  firstname: "Firstname",
  invalid_password: "Invalid Password",
  phone: "Phone",
  middleName: "Middle name",
  noRecords: "No Records",
  userName: "User name",
  selectAtLeastOneRole: "Select at least one role",
  selectAtLeastOnePermission: "Select at least one permission",
  formValidationError: "Form Validation Error",
  invalid_permission: "Invalid permission",
  invalid_phone_number_format: "Invalid phone number",
  invalid_email: "Invalid email",
  modules: "Modules",
  pageNotFound: "Page Not Found",
  toHomePage: "To Home Page",
  session_expired: "Session expired",
  sessionExpired: "Session expired",
  gender: "Gender",
  genders: "Genders",
  bank: "Bank",
  banks: "Banks",
  createBank: "Create bank",
  editBank: "Edit bank",
  internal_server_error: "Internal server error",
  deviceType: "Device type",
  deviceTypes: "Device types",
  "device types": "Device types",
  zoneGroup: "Zone group",
  zoneGroups: "Zone groups",
  "zone groups": "Zone groups",
  userTypes: "User types",
  userType: "User type",
  "user types": "User types",
  period: "Period",
  periods: "Periods",
  zone: "Zone",
  zones: "Zones",
  group: "Group",
  groups: "Groups",
  level: "Level",
  addNewPC: "Add new PC by default",
  userStatuses: "User statuses",
  userStatus: "User status",
  "user statuss": "Статусы пользователей",
  saved: "Saved",
  updated: "Updated",
  removed: "Removed",
  clientSources: "Client sources",
  clientSource: "Client source",
  "client sources": "Client sources",
  paymentTerms: "Payment terms",
  paymentTerm: "Payment term",
  "payment terms": "Payment terms",
  deviceReserveStatuses: "Device reserve statuses",
  deviceReserveStatus: "Device reserve status",
  "device reserve statuses": "Device reserve statuses",
  "device reserve statuss": "Device reserve statuses",
  device: "Device",
  devices: "Devices",
  mac: "MAC",
  ip: "IP",
  type: "Type",
  invalid_mac_address_format: "Invalid MAC address format",
  invalid_ip_address_format: "Invalid IP address format",
  buySubscriptions: "Buy subscriptions",
  buySubscription: "Buy subscription",
  "buy subscriptions": "Buy subscriptions",
  tariff: "Tariff",
  tariffs: "Tariffs",
  costPerHour: "Cost per hour",
  applyDiscountLoyaltyProgramme:
    "Apply the users discount from the loyalty programme?",
  oneTimeMinimumPaymentAtStartOfTheSession:
    "One-time minimum payment at the start of the session",
  minimumSessionTime: "Minimum session time",
  costPerMinimumSessionTime: "Minimum payment",
  clubUsers: "Club users",
  clubUser: "Club user",
  "club users": "Club users",
  sessionHistory: "Session history",
  balanceHistory: "Balance history",
  checkHistory: "Check history",
  rolesAndAccessInCAP: "Roles and access in CAP",
  "tariff settings": "Tariff settings",
  tariffSettings: "Tariff settings",
  tariffSetting: "Tariff setting",
  addPeriod: "Add period",
  setTariff: "Set tariff",
  settings: "Settings",
  "service categorys": "Service categories",
  serviceCategories: "Service categories",
  serviceCategory: "Service category",
  "launch methods": "Launch methods",
  "launch method": "Launch method",
  launchMethods: "Launch methods",
  launchMethod: "Launch method",
  "content sections": "Content sections",
  contentSections: "Content sections",
  contentSection: "Content section",
  showInShell: "Show in shell",
  content: "Content",
  newContent: "New content",
  "filter-period": {
    yesterday: "Yesterday",
    last7Days: "Last 7 Days",
    lastWeek: "Last Week",
    last30Days: "Last 30 Days",
    currentMonth: "Current Month",
    lastMonth: "Last Month",
    currentYear: "Current Year",
    lastYear: "Last Year",
    all: "All",
    select: "Select Period",
  },
  availableIn: "Available in",
  gamesUpdates: "Games Updates",
  allOffices: "All offices",
  allStatuses: "All statuses",
  allContent: "All content",
  addContent: "Add Content",
  allCategories: "All Categories",
  searchInContent: "Search in content",
  showContentToUpdate: "Show content to update",
  selectAction: "Select action",
  archive: "Archive",
  startupErrors: "Startup errors",
  pcNumber: "PC #",
  date: "Date",
  club: "Club",
  status: "Status",
  open: "Open",
  closed: "Closed",
  intoTheArchives: "Into the archives",
  makeActive: "Make active",
  makeInactive: "Make inactive",
  appointClubs: "Appoint clubs",
  restore: "Restore",
  shop: "Shop",
  cash: "Cash",
  generalSettings: "General Settings",
  sessionSettings: "Session Settings",
  taxation: "Taxation",
  cashRegisterOperations: "Cash Register Operations",
  subscriptions: "Subscriptions",
  loyaltyProgram: "Loyalty Program",
  shellInterface: "Shell Interface",
  userRegistration: "User Registration",
  clubAccounts: "Club Accounts (Keys)",
  trafficRestrictions: "Traffic Restrictions",
  sessionEndReminder: "Session End Reminder",
  timezone: "Timezone",
  language: "Language",
  currency: "Currency",
  billingStart: "Billing Start",
  sessionRestart: "Restart after session end",
  restartTime: "Time before PC restart (sec)",
  showPlayerName: "Show player name on club map",
  resetAccountBalance: "Reset account balance",
  resetAccountBalanceDays: "Reset after (days)",
  resetUnusedChecks: "Reset unused checks",
  resetUnusedChecksDays: "Reset after (days)",
  roundingAmount: "Rounding amount (decimal places)",
  defaultRate: "Default hourly rate",
  roundingPostpay: "Rounding of postpay amount (decimal places)",
  minPaymentForStaff: "Minimum payment for staff",
  taxSystem: "Tax System",
  taxType: "Tax Type",
  maxCheckAmount: "Maximum check amount",
  checkRefund: "Check refund",
  checkCancellation: "Check cancellation",
  showChange: "Show change",
  roundingRefundAmount: "Rounding of refund amount (decimal places)",
  allowGuestPurchase: "Allow guest purchase",
  allowMultipleSubscriptions: "Allow multiple subscriptions",
  offerSubscriptionOnStart: "Offer subscription at start",
  showLoyaltyProgram: "Show loyalty program",
  promoCodeVisibility: "Promo code visibility",
  replenishmentBonuses: "Replenishment bonuses",
  employeeBonuses: "Employee bonuses",
  applyDiscountToSubscriptions: "Apply discount to subscriptions",
  countSubscriptionsForLevel: "Count subscriptions for level",
  billingPriority: "Billing priority",
  steamLaunchPath: "Steam launch path",
  showUnavailableContent: "Show unavailable content",
  backgroundImage: "Background Image",
  backgroundImageHint:
    "Min. resolution - 1920x1080px. Dark tones are recommended.",
  logo: "Logo",
  image: "Image",
  logoSizeHint: "Logo size - 176x88 px.",
  showMyDocumentsFolder: "Show 'My Documents' folder",
  phoneNumber: "Phone Number",
  phoneNumberHint: "Enter the country code prefix",
  birthDate: "Birth Date",
  address: "Address",
  addresses: "Addresses",
  document: "Document",
  mandatorySourceField: "Mandatory 'How did you hear about us' field",
  selectSources: "Select sources",
  postpaidClients: "Postpaid clients",
  unregisteredClients: "Unregistered clients (Guests)",
  speedLimit: "Speed limit",
  speedLimitHint: "If traffic needs to be limited",
  sessionEndReminderMinutes: "Session end reminder (min)",
  sessionEndReminderHint:
    "How many minutes before the end of the session/subscription to notify",
  timeOutMinutes: "Time-out (min)",
  timeOutHint: "Time interval between sound notifications (min)",
  volumeLevelPercentage: "Volume level (%)",
  volumeLevelHint: "Set the notification volume level",
  soundTrack: "Soundtrack",
  default: "Default",
  custom: "Custom",
  promoCodeActive: "Promo codes active",
  promoCodeInactive: "Promo codes inactive",
  replenishmentBonusPercentage: "Percentage of replenishment",
  replenishmentBonusFixed: "Fixed amount",
  billingPriorityMain: "Main balance",
  billingPriorityBonus: "Bonus balance",
  selectFile: "Select file",
  selectBackgroundImage: "Select background image",
  selectLogoImage: "Select logo image",
  logoImage: "Logo image",
  searchUserName: "Search User Name",
  searchFirstName: "Search First Name",
  searchName: "Search Name",
  searchLastName: "Search Last Name",
  searchEmail: "Search Email",
  actions: "Actions",
  "Are you sure you want to delete this user?":
    "Are you sure you want to delete this user?",
  update: "Update",
  createUser: "Create User",
  editUser: "Edit User",
  "Failed to fetch gender data": "Failed to fetch gender data",
  "Gender created successfully": "Gender created successfully",
  "Gender updated successfully": "Gender updated successfully",
  "Please input gender!": "Please input gender!",
  "Confirm Deletion": "Confirm Deletion",
  "Are you sure you want to delete this gender?":
    "Are you sure you want to delete this gender?",
  createGender: "Create gender",
  editGender: "Edit gender",
  "Are you sure you want to delete this client source?":
    "Are you sure you want to delete this client source?",
  "Failed to fetch client source data": "Failed to fetch client source data",
  "Client source created successfully": "Client source created successfully",
  "Client source updated successfully": "Client source updated successfully",
  createClientSource: "Create client source",
  editClientSource: "Edit client source",
  "Please input client source!": "Please input client source!",
  createUserType: "Create user type",
  editUserType: "Edit user type",
  "Please input user type!": "Please input user type!",
  "User type created successfully": "User type created successfully",
  "User type updated successfully": "User type updated successfully",
  "Are you sure you want to delete this user type?":
    "Are you sure you want to delete this user type?",
  clients: "Clients",
  shortName: "Short name",
  fullName: "Full name",
  FullName: 'Full name',
  clientType: "Type of client",
  signer: "Signer",
  basisOf: "Basis of",
  powerOfAttorneyNumber: "Power of attorney number",
  integrationCode: "Integration code",
  additionalInfo: "Additional info",
  country: "Country",
  ogrn: "OGRN",
  region: "Region",
  city: "City",
  createCompany: "Create company",
  editCompany: "Edit company",
  editCompanies: "Edit company",
  selectPermission: "Select a permission",
  accountNumber: "Number of account",
  corrBank: "Correspondent bank",
  addressType: "Type of address",
  flat: "Flat",
  block: "Block",
  street: "Street",
  index: "Index",
  house: "House",
  contactType: "Type of contact",
  value: "Value",
  requisites: "Requisities",
  account: "Account",
  accounts: "Accounts",
  createAccount: "Create account",
  createAddress: "Create address",
  addContact: "Add contact",
  dateFormation: "Date formation",
  statusContract: "Contract status",
  dateSign: "Date of signing",
  addAccount: "Add account",
  addAddress: "Add address",
  contract: "Contract",
  responsible: "Responsible",
  contractTerm: "The term of the agreement",
  penaltiesSize: "The amount of the penalty",
  principle: "Principle",
  agent: "Agent",
  chats: "Chats",
  createContract: "Create contract",
  editContract: "Edit contract",
  chatNumber: "Chat #",
  send: "Send",
  enterMessage: "Enter your message",
  assignments: "Assignment",
  contractNumber: "Contract #",
  createAssignment: "Create assignment",
  exporterName: "Exporter Name",
  importContract: "Import contract",
  currencyPaymentAmount: "Currency Payment Amount",
  bankAddress: "Bank address",
  swiftCode: "SWIFT code",
  destination: "Destination",
  rateToRouble: "Rate to Rouble",
  client: "Client",
  "user type": "User type",
  "user status": "User status",
  "client source": "Client source",
  assignment: "Assignment",
  chat: "Chat",
  createWorkplace: "Create workplace",
  editWorkplace: "Edit workplace",
  application: "Application",
  "application status": "Application status",
  createApplication: "Create application",
  editApplication: "Edit application",
  applications: "Applications",
  createCity: 'Create City',
  editCity: 'Edit City',
  sysSetting: "System settings",
  'SysSetting created successfully': 'System setting created successfully',
  'SysSetting updated successfully': 'System setting updated successfully',
  code: 'Code',
  createSysSetting: 'Create system setting',
  editSysSetting: 'Edit system setting',
  editAssignment: "Edit Assignment",
  templates: 'Templates',
  file: "File",
  files: "Files",
  requisite: 'Requisite',
  'Please select date!': 'Please select date!',
  "Please select client!": 'Please select client!',
  "Please select office!": 'Please select office!',
  "Please select account number!": "Please select account number!",
  fileUploadedSuccessfully: 'File uploaded successfully',
  fileUploadError: 'File upload error',
  fileRemovedSuccessfully: 'File removed successfully',
  'Please enter proxy': 'Please enter proxy',
  'Please enter name': 'Please enter name',
  'Please enter inn': 'Please enter inn',
  'Please enter kpp': 'Please enter kpp',
  'Please enter okpo': 'Please enter okpo',
  'Please enter ceo': 'Please enter ceo',
  'Please enter email': 'Please enter email',
  'Please select basis': 'Please select basis',
  'Please enter address': 'Please enter address',
  'Please enter bank': 'Please enter bank',
  'Please enter corrAccount': 'Please enter corrAccount',
  'Please enter currentAccount': 'Please enter currentAccount',
  'Please enter bik': 'Please enter bik',
  'Please enter token': 'Please enter token',
  "officeBasedOn": {
    "Charter": "Charter",
    "Proxy": "Proxy"
  },
  'Please enter the bank name': 'Please enter the bank name',
  'Enter bank name': 'Enter bank name',
  'Please enter the correspondent account': 'Please enter the correspondent account',
  'Enter correspondent account': 'Enter correspondent account',
  'Please enter the current account': 'Please enter the current account',
  'Enter current account': 'Enter current account',
  'Please enter the BIK': 'Please enter the BIK',
  'Enter BIK': 'Enter BIK',
  validationErrorTitle: 'Validation error',
  validationErrorMessage: 'Please correct the following errors',
  'Office account created successfully': 'Office account created successfully',
  'Office deleted successfully': 'Office deleted successfully',
  'Please fill in all required fields': 'Please fill in all required fields',
  'Office updated successfully': 'Office updated successfully',
  'Office created successfully': 'Office created successfully',
  "clientTypes": {
    "Individual": "Individual",
    "LegalEntity": "LegalEntity"
  },
  "clientBasisOf": {
    "Charter": "Charter",
    "PowerOfAttorney": "PowerOfAttorney",
    "Certificate": "Certificate",
  },
  "clientAddressType": {
    "Physical": "Physical",
    "Legal": "Legal"
  },
  contact: "Contact",
  "clientContactType": {
    "Phone": "Phone",
    "Email": "Email",
    "Telegram": "Telegram"
  },
  noData: "No data",
  noMessages: "No messages",
  'Please input signer': 'Please input signer',
  'Please input post': 'Please input post',
  'Please input powerOfAttorneyNumber': 'Please input power of attorney number',
  'Please input integrationCode': 'Please input integration code',
  'Please input additionalInfo': 'Please input additional info',
  'Please select at least one country': 'Please select at least one country',
  'Please input ogrn': 'Please input ogrn',
  'Please select at least one region': 'Please select at least one region',
  'Please select at least one city': 'Please select at least one city',
  'Please input kpp': 'Please input kpp',
  'Please input inn': 'Please input inn',
  'Please input okpo': 'Please input okpo',
  'Please input currency': 'Please input currency',
  'Please input currency code': 'Пожалуйста, введите код валюты',
  currencyName: "Currency name",
  createCurrency: "Create currency",
  editCurrency: "Edit currency",
  'Created successfully': 'Created successfully',
  'Updated successfully': 'Updated successfully',
  'Removed successfully': 'Removed successfully',
  'Are you sure you want to delete?': 'Are you sure you want to delete?',
  'Yes': 'Yes',
  'Cancel': 'Cancel',
  'Select a role': 'Select a role',
  'Select a module': 'Select a module',
  'Name': 'Name',
  'Module created successfully': 'Module created successfully',
  'Role created successfully': 'Role created successfully',
  currencies: "Currencies",
  cities: "Cities",
  countires: "Countries",
  regions: "Regions",
  createCountry: "Create country",
  editCountry: "Edit country",
  'Please input country': 'Please input country',
  'Please input country code': 'Please input country code',
  'Country created successfully': 'Country created successfully',
  createRegion: "Create region",
  editRegion: "Edit region",
  'Please input region': 'Please input region',
  'Please input city': 'Please input city',
  createUserStatus: "Create user status",
  editUserStatus: "Edit user status",
  'Please input user status': 'Please input user status',
  'new application': 'New application',
  'contract negotiation': 'Contract negotiation',
  'contract signing': 'Contract signing',
  'invoice negotiation': 'Invoice negotiation',
  'assignment negotiation': 'Assignment negotiation',
  'awaiting payments': 'Awaiting payments',
  'assignment execution': 'Assignment execution',
  'awaiting confirmation': 'Awaiting confirmation',
  'act signing': 'Act signing',
  'toWork': 'To work',
  'sayHello': 'Say hello',
  'send requisits': 'Send reauisits',
  'form an agreement': 'Form an agreement',
  'contract template': 'Contract template',
  'signing': 'SignIn',
  'signed': 'Signed',
  'approve': 'Approve',
  'send invoice requirements': 'Send invoice requirements',
  'to assignment negotiation': 'To assignment negotiation',
  'approve SWIFT': 'Approve SWIFT',
  'send instructions': 'Send instructions',
  'instructions approved': 'Instructions approved',
  'agree on course': 'Agree on course',
  'payments received': 'Payments received',
  'execute the order': 'Execute the order',
  'signing of acts': 'Signing of acts',
  'the acts were signed': 'The acts were signed',
  'sended successfully': 'Sended successfully',
  'application number': 'Application №',
  'stage': 'Stage',
  'application date': 'Application date',
  'responsibleBy': 'Responsible manager',
  'operativeBy': 'Operator',
  'application parameters': 'Application parameters',
  'Name of goods/services in the contract/invoice': 'Name of goods/services in the contract/invoice',
  'recipients bank details': 'Recipient’s bank details',
  'import contact': 'Import contact',
  'conditions for making a payment': 'Payment conditions',
  'letter of credit': 'Letter of credit',
  'due date': 'Due date',
  'transfer amount': 'Transfer amount',
  'the commission that the client receives': 'Commission received by client',
  'exchange rate': 'Exchange rate',
  'prize': 'Bonus',
  'total amount': 'Total amount',
  'credit body': 'Principal amount',
  'bank interest': 'Bank interest',
  'total': 'Total',
  'profit': 'Profit',
  'Office': 'Office',
  'client details': 'Client details',
  'company name': 'Company name',
  'signing method': 'Signing method',
  'signing date': 'Signing date',
  'contract number': 'Contract number',
  'contract templates': 'Contract templates',
  "contractStatus": {
    "New": "New",
    "Signing": "Signing",
    "Active": "Active",
    "Inactive": "Inactive"
  },
  paymentAmount: "Payment amount",
  destinationOffice: "Destination office",
  currencyOffice: "Currency office",
  officeAccount: "Office account",
  remunerationAmount: "Remuneration amount",
  remunerationCurrency: "Remuneration currency",
  letterOfCredit: "Letter of credit",
  'Please enter contract ID': 'Please enter contract number',
  'Please enter client ID': 'Please select client',
  'Please enter office ID': 'Please select office',
  'Please select formation date': 'Please select formation date',
  'Please select signature date': 'Please select signature date',
  'Please enter exporter name': 'Please enter exporter name',
  'Please enter import contract': 'Please enter import contract',
  'Please enter payment amount': 'Please enter payment amount',
  'Please select currency ID': 'Please select currency',
  'Please enter bank name': 'Please enter bank name',
  'Please enter bank address': 'Please enter bank address',
  'Please enter account number': 'Please enter account number',
  'Please enter SWIFT code': 'Please enter SWIFT code',
  'Please enter destination': 'Please enter destination',
  'Please enter payment terms': 'Please enter payment terms',
  'Please enter rate to rouble': 'Please enter rate to rouble',
  'Please enter payment amount for office': 'Please enter payment amount for office',
  'Please enter destination office': 'Please enter destination office',
  'Please select office currency': 'Please select office currency',
  'Please select office account': 'Please select office account',
  'Please enter remuneration amount': 'Please enter remuneration amount',
  'Please select remuneration currency': 'Please select remuneration currency',
  'Please select office': 'Please select office',
  'Please input penalty': 'Please input penalty',
  'Please input your login': 'Please input your login',
  'Please input your username': 'Please input your username',
  'Please input your password': 'Please input your password',
  'Please input your firstName': 'Please input your firstName',
  'Please input your lastName': 'Please input your lastName',
  'Please select an office': 'Please select an office',
  'Please select at least one role': 'Please select at least one role',
  'Please select a gender': 'Please select a gender',
  'Please select a user type': 'Please select a user type',
  'Please input your email': 'Please input your email',
  "userStatusPage": {
    "Pending": "Pending",
    "Active": "Active",
    "Suspended": "Suspended",
    "Locked": "Locked"
  },
  'Validation Error': 'Validation Error',
  'Please correct the highlighted fields and try again.': 'Please correct the highlighted fields and try again',
  'SwiftSum': 'Swift sum',
  'diadoc': 'Use diadoc',
  'manual': 'Use manual',
  'back': 'Back',
  'validation_errors': {
    'please_enter_name': 'Please enter the name',
    'please_enter_kpp': 'Please enter KPP',
    'please_enter_inn': 'Please enter INN',
    'please_enter_application_number': 'Please enter the application number',
    'please_enter_application_date': 'Please enter the application date',
    'please_enter_stage': 'Please enter the stage',
    'please_enter_responsibleBy': 'Please enter the responsible person',
    'please_enter_client': 'Please enter the client',
    'please_enter_products': 'Please enter the products',
    'please_enter_recipientBankAccountNumber': 'Please enter the recipient bank account number',
    'please_enter_recipientBankSwiftCode': 'Please enter the recipient bank SWIFT code',
    'please_enter_recipientBankAddress': 'Please enter the recipient bank address',
    'please_enter_recipientBankBankName': 'Please enter the recipient bank name',
    'please_enter_recipientBankPaymentPurpose': 'Please enter the payment purpose',
    'please_enter_recipientBankImportContract': 'Please enter the import contract',
    'please_enter_paymentTermsLetterOfCredit': 'Please select if there is a letter of credit',
    'please_enter_paymentTermsExecutionPeriod': 'Please enter the due date',
    'please_enter_paymentTermsTransferAmount': 'Please enter the transfer amount',
    'please_enter_paymentTermsRate': 'Please enter the commission that the client receives',
    'please_enter_paymentTermsTransferCurrency': 'Please select the currency',
    'please_enter_paymentTermsExchangeRate': 'Please enter the exchange rate',
    'please_enter_paymentTermsSwift': 'Please enter the SWIFT sum',
    'please_enter_paymentTermsBonus': 'Please enter the bonus',
    'please_enter_paymentTermsTotalAmount': 'Please enter the total amount',
    'please_enter_paymentTermsPrincipal': 'Please enter the credit body',
    'please_enter_paymentTermsBankInterest': 'Please enter the bank interest',
    'please_enter_paymentTermsTotalSum': 'Please enter the total sum',
    'please_enter_paymentTermsProfit': 'Please enter the profit',
    'please_enter_paymentTermsOffice': 'Please enter the office',
    'please_enter_clientDetailsCompanyName': 'Please enter the company name',
    'please_enter_clientDetailsInn': 'Please enter the INN',
    'please_enter_clientDetailsFullName': 'Please enter the full name',
    'please_enter_clientDetailsBankName': 'Please enter the bank name',
    'please_enter_clientDetailsPosition': 'Please enter the position',
    'please_enter_clientDetailsAccountNumber': 'Please enter the account number',
    'please_enter_clientDetailsKpp': 'Please enter the KPP',
    'please_enter_clientDetailsCorrespondentAccount': 'Please enter the correspondent account',
    'please_enter_clientDetailsAddress': 'Please enter the address',
    'please_enter_clientDetailsBik': 'Please enter the BIK',
    'please_enter_clientDetailsEmail': 'Please enter the email',
    'please_enter_clientDetailsSignatureMethod': 'Please enter the signing method',
    'please_enter_clientDetailsSignatureDate': 'Please enter the signing date',
    'please_enter_clientDetailsPowerOfAttorney': 'Please enter the power of attorney',
    'please_enter_clientDetailsContractDurationYears': 'Please enter the contract term',
    'please_enter_clientDetailsContractNumber': 'Please enter the contract number',
    'please_enter_clientDetailsPenaltySize': 'Please enter the penalty size',
    'please_select_bank': 'Please select the bank',
    'please_account_currency': 'Please enter account currency',
    'please_enter_companyName': 'Please enter company name',
    'please_enter_companyAddress': 'Please enter company address',
    'please_enter_actNumber': 'Please enter act number',
    'please_enter_dateExecutionSwift': 'Please enter date execution Swift',
    'please_enter_dateActSigning': 'Please enter date act signing',
    'please_enter_actualExchangeRate': 'Please enter actual Exchange Rate',
    'please_enter_dateCashReceipt': 'Please enter date Cash Receipt',
    'please_enter_amountAfterConversion': 'please enter amount After Conversion',
    'please_enter_application_source': 'Please enter application source',
    'please_input_dateAssignmentSigning':'Please input date assignment signing',
    'please_input_assignmentNumber':'Please input assignment number',
    'please_enter_removeFromReport': 'Please enter remove from report',
    'please_enter_paymentStatus': 'Please enter payment status',
    'please_enter_comments': 'Please enter comments',
  },
  fullAddress: 'Address',
  isGroup: 'Group',
  documents: 'Documents',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  calculation: 'Calculation',
  'Select status': 'Select status',
  'Select responsibleBy': 'Select responsibleBy',
  'Funds have been credited to the account': 'Funds have been credited to the account',
  'please enter a description': 'Please enter a description',
  'enter description': 'Enter description',
  'assignment signing': 'Assignment signing',
  accountCurrency: 'Account currency',
  chatId: 'Chat Id',
  actNumber: 'Act #',
  dateExecutionSwift: 'Date execution Swift',
  dateActSigning: 'Date act signing',
  actualExchangeRate: 'Actual Exchange Rate',
  dateCashReceipt: 'Date Cash Receipt',
  amountAfterConversion: 'Amount After Conversion',
  generateExcel: 'Generate Excel',
  'Client created successfully': 'Client created successfully',
  'Client updated successfully': 'Client updated successfully',
  'Client deleted successfully': 'Client deleted successfully',
  'Account created successfully': 'Account created successfully',
  'Account updated successfully': 'Account updated successfully',
  'Account deleted successfully': 'Account deleted successfully',
  'Address created successfully': 'Address created successfully',
  'Address updated successfully': 'Address updated successfully',
  'Address deleted successfully': 'Address deleted successfully',
  'Contact created successfully': 'Contact created successfully',
  'Contact updated successfully': 'Contact updated successfully',
  'Contact deleted successfully': 'Contact deleted successfully',
  'Please input your basisOf': 'Please input your basisOf',
  'Please input your clientType': 'Please input your client type',
  'Please input client name': 'Please input client name',
  'Please input client fullName': 'Please input client fullName',
  'Please input corrAccount': 'Please input corrAccount',
  'Please select at least one currency': 'Please select at least one currency',
  'Please input bank name': 'Please input bank name',
  'Please input contact value': 'Please input contact value',
  'Please input a valid email': 'Please input a valid email',
  'application source': 'Application source',
  'document templates': 'Document templates',
  'create client': 'Create client',
  'edit client': 'Edit client',
  'create app': 'Create application',
  'dateAssignmentSigning': 'Date assignment signing',
  'assignmentNumber': 'Assignment number',
  Pending: 'Pending',
  Executed: 'Executed',
  Returned: 'Returned',
  FullRefund: 'FullRefund',
  removeFromReport: 'Remove from report',
  comments: 'Comments',
  paymentStatus: 'Payment status',
  endDate: 'end Date',
  startDate: 'start Date',
  recipientBankAddress: 'Bank Address',
  companyAddress: 'Company Address',
  clientDetailsAccountNumber: 'Account Number',
  'searchApplicationNumber': 'Search application number',
  'searchTransferAmount': 'Search transfer amount',
  'searchClient': 'Search client',
  'searchChat': 'Search chat',
  'searchResponsibleBy': 'Search responsible by',
  application_name_must_be_unique_exception: 'Application name must be unique',
  'has_linked_entities': 'Has Linked Entities',
  editApplicationStatus: 'Edit Application Status',
  position: 'Position',
  isFinish: 'Is Finish',
  applicationStatuses: 'Application Statuses',
}; 
